import * as fragments from "./fragments";

export const products = `
  query products($ids: [ID!]!) {
    nodes(ids: $ids) {
      ...on Product {
        ${fragments.product}
      }
    }
  }
`;

export const product = `
  query product($handle: String!) {
    productByHandle(handle: $handle) {
      ${fragments.product}
    }
  }
`;

export const variant = `
  query productVariant($ids: [ID!]!) {
    nodes(ids: $ids) {
      ...on ProductVariant {
        ${fragments.variant}
      }
    }
  }
`;

export const productsByTag = (group) => `
  query {
    products(query: "tag:'${group}'", first: 20, sortKey: TITLE) {
      edges {
        cursor
        node {
          ${fragments.product}
        }
      }
    }
  }
`;

export const productsByCollection = (handle, productsQuery) => `
  query {
    collection(handle: "${handle}") {
      handle
      products(${productsQuery}) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          cursor
          node {
            ${fragments.product}
          }
        }
      }
      interstitialBannersV2: metafield(namespace: "content", key: "interstitial_banners_v2") {
        references(first: 10) {
          edges {
            node {
              ... on Metaobject {
                heading: field(key: "heading") {
                  value
                }
                ctaText: field(key: "cta_text") {
                  value
                }
                ctaUrl: field(key: "cta_url") {
                  value
                }
                contentVerticalAlign: field(key: "content_vertical_align") {
                  value
                }
                imageDesktop: field(key: "image") {
                  reference {
                    ... on MediaImage {
                      presentation {
                        asJson(format: IMAGE)
                      }
                      image {
                        altText
                        url
                      }
                    }
                  }
                }
                imageMobile: field(key: "image_mobile") {
                  reference {
                    ... on MediaImage {
                      presentation {
                        asJson(format: IMAGE)
                      }
                      image {
                        altText
                        url
                      }
                    }
                  }
              }
                overlayOpacity: field(key: "overlay_opacity") {
                  value
                }
                cardWidth: field(key: "card_width") {
                  value
                }
                displayAfterXCards: field(key: "display_after_x_cards") {
                  value
                }
              }
            }
          }
        }
      }
    }
  }

`;

export const getFilters = (handle, productsQuery) => `
  query {
    collection(handle: "${handle}") {
      handle
      products(${productsQuery}) {
        filters {
          id
          label
          type
          values {
            id
            label
            count
            input
          }
        }
      }
    }
  }
`;

export const getCursors = (handle, productsQuery) => `
  query getCursors {
    collection(handle: "${handle}") {
      products(${productsQuery}) {
        edges{
          cursor
        }
        pageInfo{
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const getArticles = `
query getArticles($blogHandle: String, $first: Int, $sortKey: ArticleSortKeys, $reverse: Boolean, $after: String, $query: String){
	blog(handle: $blogHandle) {
    id
    articles(first: $first, sortKey: $sortKey, reverse: $reverse, after: $after, query: $query) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ${fragments.article}
        }
      }
    }
  }
}
`;

export const getArticle = `
query getArticle($id: ID!){
	article(id: $id) {
    ${fragments.article}
  }
}

`;

export const getCompareModalData = `
query getCompareModalData($handle: MetaobjectHandleInput) {
  metaobject(handle: $handle) {
    id
    key: field(key: "key") {
      value
    }
    heading: field(key: "heading") {
      value
    }
    copy: field(key: "copy") {
      value
    }
    ctaText: field(key: "cta_text") {
      value
    }
    ctaUrl: field(key: "cta_url") {
      value
    }
    compareProducts: field(key: "compare_products") {
      references(first: 100) {
        edges {
          node {
            ... on Metaobject {
              key: field(key: "key") {
                value
              }
              product: field(key: "product") {
                reference {
                  ... on Product {
                    id
                    title
                    priceRange {
                      minVariantPrice {
                        amount
                      }
                    }
                    onlineStoreUrl
                    featuredImage {
                      url
                      altText
                    }
                    compatibleProducts: metafield(namespace: "compare", key: "compatible_products") {
                      references(first: 100) {
                        edges {
                          node {
                            ... on Metaobject {
                              product: field(key: "product") {
                                reference {
                                  ... on Product {
                                    id
                                  }
                                }
                              }
                              image: field(key: "image") {
                                reference {
                                  ... on MediaImage {
                                    image {
                                      url
                                      altText
                                    }
                                  }
                                }
                              }
                              handle
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              customMedia: field(key: "custom_media") {
                reference {
                  ... on MediaImage {
                    image {
                      url
                      altText
                    }
                  }
                  ... on Video {
                    id
                    sources {
                      height
                      width
                      mimeType
                      format
                      url
                    }
                    previewImage {
                      url
                      altText
                    }
                  }
                }
              }
              description: field(key: "description") {
                value
              }
              compareContent: field(key: "compare_content") {
                references(first: 100) {
                  edges {
                    node {
                      ... on Metaobject {
                        key: field(key: "key") {
                          value
                        }
                        svg: field(key: "image_svg") {
                          value
                        }
                        content: field(key: "content") {
                          value
                        }
                      }
                    }
                  }
                }
              }
              dimensionsRow1: field(key: "dimensions_row_1") {
                value
              }
              dimensionsRow2: field(key: "dimensions_row_2") {
                value
              }
              dimensionsRow3: field(key: "dimensions_row_3") {
                value
              }
              dimensionsRow4: field(key: "dimensions_row_4") {
                value
              }
              dimensionsRow5: field(key: "dimensions_row_5") {
                value
              }
              dimensionsRow6: field(key: "dimensions_row_6") {
                value
              }
              keyFeatures: field(key: "key_features") {
                value
              }
            }
          }
        }
      }
    }
    dimensionsRow1Heading: field(key: "dimensions_row_1_heading") {
      value
    }
    dimensionsRow2Heading: field(key: "dimensions_row_2_heading") {
      value
    }
    dimensionsRow3Heading: field(key: "dimensions_row_3_heading") {
      value
    }
    dimensionsRow4Heading: field(key: "dimensions_row_4_heading") {
      value
    }
    dimensionsRow5Heading: field(key: "dimensions_row_5_heading") {
      value
    }
    dimensionsRow6Heading: field(key: "dimensions_row_6_heading") {
      value
    }
    compatibleProductListHeading: field(key: "compatible_product_list_heading") {
      value
    }
    compatibleProductList: field(key: "compatible_product_list") {
      references(first: 100) {
        edges {
          node {
            ... on Product {
              id
              title
              priceRange {
                minVariantPrice {
                  amount
                }
              }
              featuredImage {
                url
                altText
              }
            }
          }
        }
      }
    }
    compatibilityGrid: field(key: "compatibility_grid") {
      references(first: 100) {
        edges {
          node {
            ... on Product {
              id
              title
            }
          }
        }
      }
    }
  }
}
`;

export const getCertifiedGuidesData = `
  query getMetaobjectByHandle($input: MetaobjectHandleInput!) {
    metaobject(handle: $input) {
      id
      handle
      updatedAt
      hash: field(key: "hash") {
        value
      }
      rawData: field(key: "raw_data") {
        value
      }
    }
  }
`
